import _startCase from 'lodash/startCase'

import { MentionData, MultiMentionData } from '@draft-js-plugins/mention'

export function customEntityTransform(entity, text) {
  if (entity.type === 'mention') {
    return `<a>${text}</a>`
  }

  if (entity.type === 'emoji') {
    return `<span class="text-2xl">${entity.data?.emojiUnicode}</span>`
  }
}

export function processMentionedEntity(body) {
  // e.g: @[User Name](userId)
  return body.replace(/@\[(.*?)\]\((.*?)\)/g, `<a data-user-id="$2">@$1</a>`)
}

export const suggestionsFilter = (
  searchValue: string,
  suggestions: MultiMentionData | MentionData[],
  trigger?: string
): MentionData[] => {
  const value = searchValue.toLowerCase()
  const triggerSuggestions: MentionData[] =
    trigger && !Array.isArray(suggestions) ? suggestions[trigger] : (suggestions as MentionData[])
  const filteredSuggestions = triggerSuggestions.filter(
    (suggestion) => !value || suggestion.name.match(new RegExp(value, 'i'))
  )
  const length = filteredSuggestions.length < 10 ? filteredSuggestions.length : 10
  return filteredSuggestions.slice(0, length)
}

/**
 * Capitalizes the first and last name of the user,
 * if the username is an email, it will return the email as is
 * @param username
 * @returns
 */
export function capitalizeFirstLastNames(username: string) {
  if (username.includes('@')) {
    return username
  }
  return _startCase(username)
}
